module.exports = __webpack_public_path__ + "media/images/ohap_instructor_resources-3502a543a245fd00f5e73bd3f708a4df.png";